export default __webpack_public_path__ + "static/macabalan-port-ad1ccc785ad0e41d3d0b053b9152fa90.jpg";